import {
	EnhancedCheckboxRHF,
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

// interface IBillingProfilePanel extends ITest {
//     formMethods: any;
// }

interface IBillingProfileSetupPanel extends ITest {
	formMethods: any;
}
export const BillingProfileSetupLeftPanel: FC<IBillingProfileSetupPanel> = ({
	formMethods,
}) => {
	return (
		<>
			<RHookFormTextFieldWithLabel
				label="Profile Label"
				id="profileLabel"
				testId={`profile-label`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedCheckboxRHF
				name="isGlobal"
				checked={false}
				testId="is-global`"
				id="isGlobal"
				checkboxLabel={"Global"}
			/>
			<RHookFormDatePicker
				name="dateEffective"
				testId="date-effective"
				label="Effective Date"
				labelPosition={LabelPosition.Top}
			// format="DD MMM, YYYY"
			/>
			<RHookFormDatePicker
				name="endDate"
				testId="end-date"
				label="End Date"
				labelPosition={LabelPosition.Top}
			// format="DD MMM, YYYY"
			/>
			<EnhancedDropDownRHFWithLabel
				label="Profile Type"
				selectName="profileType"
				testId={`profile-type`}
				labelPosition={LabelPosition.Top}
				items={[
					{ label: "Account Professional", value: 100 },
					{ label: "Direct Cclient", value: 200 },
				]}
				selectedItem={100}
				labelColumns={4}
				fieldColumns={8}
			/>
			<RHookFormNumberFieldWithLabel
				label="Cheque Employee"
				id="chequeEmployee"
				testId={`cheque-employee`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Direct Deposit"
				id="directDeposit"
				testId={`cheque-employee`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Weekly Cheque"
				id="weeklyCheque"
				testId={`weekly-cheque`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Weekly Direct Deposit"
				id="weeklyDirectDeposit"
				testId={`weekly-direct-deposit`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Min Invoice"
				id="minInvoice"
				testId={`min-invoice`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Min Weekly Invoice"
				id="minWeeklyInvoice"
				testId={`min-weekly-invoice`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Setup Fee"
				id="setupFee"
				testId={`setup-fee`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Stat Holiday"
				id="statHoliday"
				testId={`stat-holiday`}
				labelPosition={LabelPosition.Top}
			/>


			<RHookFormNumberFieldWithLabel
				label="T4"
				id="t4"
				testId={`t4`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="T4 Summary"
				id="t4Summary"
				testId={`t4-summary`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Payroll Remmitance"
				id="payrollRemmitance"
				testId={`payroll-remmitance`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="EHT Remmitance"
				id="ehtRemmitance"
				testId={`eht-remmitance`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="WSIB Remmitance"
				id="statHolidaywsibRemmitance"
				testId={`stat-holidaywsib-remmitance`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Direct Deposit File"
				id="directDepositFile"
				testId={`direct-deposit-file`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Net Pay Split Account"
				id="netPaySplitAccount"
				testId={`net-pay-split-account`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Buss Payment Cheque"
				id="bussPaymentCheque"
				testId={`buss-payment-cheque`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Buss Payment DD"
				id="bussPaymentDd"
				testId={`buss-payment-dd`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Quebec Remmitance"
				id="quebecRemmitance"
				testId={`quebec-remmitance`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Employee Advance"
				id="employeeAdvance"
				testId={`employee-advance`}
				labelPosition={LabelPosition.Top}
			/>
			
		</>
	);
};
